export const TelephonyTabBarTestIds = {
  getTab: key => `telephony-tabs.tab-${key}`,
};
